var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"type":_vm.getStatus()}},[_vm._v(_vm._s(_vm.getStatusText())+" "+_vm._s(_vm.additionalMessage))])
}
var staticRenderFns = []

export { render, staticRenderFns }